"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTagRequestUrl = void 0;
const info_1 = require("./info");
const utils_1 = require("./utils");
function getTagExt(tagProperties) {
    var _a;
    const b64 = ((_a = tagProperties._opts) === null || _a === void 0 ? void 0 : _a.b64) || tagProperties.b64;
    const decodedB64 = b64 ? (0, utils_1.decodeB64)(b64) : null;
    return decodedB64 ? decodedB64.tag_ext : null;
}
function buildTagRequestUrl(tagProperties) {
    const { _tag, _opts } = tagProperties;
    const tagExt = getTagExt(tagProperties);
    const tag = _tag + (tagExt && _tag.indexOf(`-${tagExt}`) === -1 ? `-${tagExt}` : ``);
    const domain = (_opts === null || _opts === void 0 ? void 0 : _opts.custom_domain) || 'ads.revjet.com';
    const properties = (0, info_1.collectInfo)(tagProperties);
    const query = Object.keys(properties)
        .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(properties[key]))
        .join('&');
    return `https://${domain}/${tag}?${query}`;
}
exports.buildTagRequestUrl = buildTagRequestUrl;
//# sourceMappingURL=tag-request.js.map